import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { SubmissionBaseQuestionPreview } from './base-question.component';
import styled from '@xstyled/styled-components';
import { Radio, Space } from 'antd';
import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var AnswerContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  img {\n    max-width: 100%;\n  }\n"])));
var AnswerItem = styled(Radio)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  cursor: default;\n"])));
var AnswerTitle = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: ", ";\n\n  p {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray11);
var AnswerItemLayout = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n"])));
export var SubmissionSingleChoiceQuestionPreview = function SubmissionSingleChoiceQuestionPreview(props) {
  var question = props.question,
      isSkipped = props.isSkipped,
      answer = props.answer,
      label = props.label,
      isCorrect = props.isCorrect;

  var renderAnswers = function renderAnswers() {
    if (isSkipped) {
      return question.answers.map(function (a, index) {
        var isCorrectAnswer = question.correctAnswers.some(function (c) {
          return c.answerId === a.id.toString();
        });
        var answerDescription = isCorrectAnswer ? "".concat(a.description, " <label style=\"color: ").concat(styleVariables.colors.green1, "; margin-left: 10px\">(").concat(label.correctAnswer, ")</label>") : "".concat(a.description);
        return /*#__PURE__*/_jsx(AnswerItemLayout, {
          children: /*#__PURE__*/_jsx(AnswerItem, {
            value: a.id.toString(),
            disabled: true,
            children: /*#__PURE__*/_jsx(AnswerTitle, {
              value: answerDescription
            })
          }, a.id.toString())
        }, index);
      });
    }

    return question.answers.map(function (a, index) {
      var _answer$value;

      var isSelectedAnswer = ((_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.answerId) === a.id.toString();
      var isCorrectAnswer = question.correctAnswers.some(function (c) {
        return c.answerId === a.id.toString();
      });
      var answerDescription = isCorrectAnswer ? "".concat(a.description, " <label style=\"color: ").concat(styleVariables.colors.green1, "; margin-left: 10px\">(").concat(label.correctAnswer, ")</label>") : "".concat(a.description);
      return /*#__PURE__*/_jsx(AnswerItemLayout, {
        children: /*#__PURE__*/_jsx(AnswerItem, {
          value: a.id.toString(),
          checked: isSelectedAnswer,
          disabled: true,
          children: /*#__PURE__*/_jsx(AnswerTitle, {
            value: answerDescription
          })
        }, a.id.toString())
      }, index);
    });
  };

  var isCorrectAnswerMissing = useMemo(function () {
    return !question.correctAnswers || question.correctAnswers.length === 0;
  }, [question.correctAnswers]);
  return /*#__PURE__*/_jsx(SubmissionBaseQuestionPreview, _objectSpread(_objectSpread({}, props), {}, {
    isSkipped: isSkipped,
    isCorrect: isCorrect,
    score: answer === null || answer === void 0 ? void 0 : answer.score,
    hasGraded: answer === null || answer === void 0 ? void 0 : answer.hasGraded(),
    isCorrectAnswerMissing: isCorrectAnswerMissing,
    children: /*#__PURE__*/_jsx(AnswerContainer, {
      direction: "vertical",
      children: renderAnswers()
    })
  }));
};